"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 3,
  y: 21,
  fill: "var(--sds--ursa-icons--selected-color, currentColor)",
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.465 5.095c.615-1.292 2.454-1.292 3.07 0l5.597 11.754a.7.7 0 0 1-1.264.602l-1.31-2.751H7.442l-1.31 2.751a.7.7 0 0 1-1.264-.602zM8.11 13.3h7.782l-3.62-7.603a.3.3 0 0 0-.542 0z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=TextColorWithSelectionIcon24.js.map